<template>
  <b-modal size="lg" v-model="visible" title="Cambiar Instrumento de Pago">
    <b-row>
      <b-col sm="4">
        <b-form-group label="Fecha">
          <b-form-input type="date" v-model="form.fecha"></b-form-input>
        </b-form-group>
      </b-col>
      <b-col sm="8">
        <!--b-form-group label="Asegurado">
          <b-form-select v-model="form.asegurado" :options="opcionesAseg"></b-form-select>
        </b-form-group-->
        <b-form-group label="Póliza">
          <b-form-input disabled :value="nroPoliza"/>
        </b-form-group>
      </b-col>
      <b-col sm="12">
        <b-form-group label="Opciones de Pago">
          <b-form-select v-model="form.opcion" :options="opcionesPago"></b-form-select>
        </b-form-group>
      </b-col>
    </b-row>

    <div v-if="form.opcion == 1">
      <b-card>
        <b-row>
          <b-col sm="6">
            <b-form-radio v-model="form.tarjeta.marca" name="tarjeta" value="Mastercard">Mastercard</b-form-radio>
          </b-col>
          <b-col sm="6">
            <b-form-radio v-model="form.tarjeta.marca" name="tarjeta" value="Visa">Visa</b-form-radio>
          </b-col>
          <b-col sm="6">
            <b-form-radio v-model="form.tarjeta.marca" name="tarjeta" value="Naranja">Naranja</b-form-radio>
          </b-col>
          <b-col sm="6">
            <b-form-radio v-model="form.tarjeta.marca" name="tarjeta" value="Mastercard - Naranja">Mastercard - Naranja
            </b-form-radio>
          </b-col>
          <b-col sm="6">
            <b-form-radio v-model="form.tarjeta.marca" name="tarjeta" value="Visa - Naranja">Visa - Naranja
            </b-form-radio>
          </b-col>
          <b-col sm="6">
            <b-form-radio v-model="form.tarjeta.marca" name="tarjeta" value="American Express">American Express
            </b-form-radio>
          </b-col>
        </b-row>
      </b-card>

      <b-row>
        <b-col sm="12">
          <b-form-group label="Nº de Tarjeta (16 dígitos)">
            <b-form-input
              type="text"
              v-model="form.tarjeta.numero"
              v-mask="'#### #### #### ####'"
              @blur="$v.form.tarjeta.numero.$touch"
              :state="$v.form.tarjeta.numero.$dirty ? !$v.form.tarjeta.numero.$error : null"
            ></b-form-input>
          </b-form-group>
        </b-col>
        <b-col sm="12">
          <b-form-group label="Titular de la Tarjeta">
            <b-form-input
              type="text"
              v-model="form.tarjeta.titular"
              @blur="$v.form.tarjeta.titular.$touch"
              :state="$v.form.tarjeta.titular.$dirty ? !$v.form.tarjeta.titular.$error : null"
            ></b-form-input>
          </b-form-group>
        </b-col>
        <b-col sm="6">
          <b-form-group label="Vencimiento">
            <b-form-input
              type="text"
              v-model="form.tarjeta.vencimiento"
              v-mask="'##/##'"
              @blur="$v.form.tarjeta.vencimiento.$touch"
              :state="$v.form.tarjeta.vencimiento.$dirty ? !$v.form.tarjeta.vencimiento.$error : null"
            ></b-form-input>
          </b-form-group>
        </b-col>
        <b-col sm="6">
          <b-form-group label="Banco Emisor">
            <b-form-input
              type="text"
              v-model="form.tarjeta.banco"
              @blur="$v.form.tarjeta.banco.$touch"
              :state="$v.form.tarjeta.banco.$dirty ? !$v.form.tarjeta.banco.$error : null"
            ></b-form-input>
          </b-form-group>
        </b-col>
      </b-row>
    </div>

    <div v-if="form.opcion == 2">
      <b-card>
        <b-row>
          <b-col>
            <b-form-radio v-model="form.cuenta.tipo" value="Caja de Ahorro">Caja de Ahorro</b-form-radio>
          </b-col>
          <b-col>
            <b-form-radio v-model="form.cuenta.tipo" value="Cuenta Corriente">Cuenta Corriente</b-form-radio>
          </b-col>
        </b-row>
      </b-card>

      <b-row>
        <b-col sm="12">
          <b-form-group label="Nº de Cuenta (16 dígitos)">
            <b-form-input type="text" min="16" max="16"
              v-model="form.cuenta.numero"
              v-mask="'################'"
              @blur="$v.form.cuenta.numero.$touch"
              :state="$v.form.cuenta.numero.$dirty ? !$v.form.cuenta.numero.$error : null"
            />
          </b-form-group>
        </b-col>
        <b-col sm="5">
          <b-form-group label="Titular de la Cuenta">
            <b-form-input
              type="text" v-model="form.cuenta.titular"
              @blur="$v.form.cuenta.titular.$touch"
              :state="$v.form.cuenta.titular.$dirty ? !$v.form.cuenta.titular.$error : null"
            ></b-form-input>
          </b-form-group>
        </b-col>
        <b-col sm="5">
          <b-form-group label="Banco">
            <b-form-input
              type="text"
              v-model="form.cuenta.banco"
              @blur="$v.form.cuenta.banco.$touch"
              :state="$v.form.cuenta.banco.$dirty ? !$v.form.cuenta.banco.$error : null"
            ></b-form-input>
          </b-form-group>
        </b-col>
        <b-col sm="2">
          <b-form-group label="Sucursal">
            <b-form-input
              type="text"
              v-model="form.cuenta.sucursal"
              @blur="$v.form.cuenta.sucursal.$touch"
              :state="$v.form.cuenta.sucursal.$dirty ? !$v.form.cuenta.sucursal.$error : null"
            ></b-form-input>
          </b-form-group>
        </b-col>
        <b-col sm="12">
          <b-form-group label="CBU (22 dígitos)">
            <b-form-input
              type="text"
              min="22"
              max="22"
              v-mask="'######################'"
              v-model="form.cuenta.cbu"
              @blur="$v.form.cuenta.cbu.$touch"
              :state="$v.form.cuenta.cbu.$dirty ? !$v.form.cuenta.cbu.$error : null"
            ></b-form-input>
          </b-form-group>
        </b-col>
      </b-row>
    </div>

    <template v-slot:modal-footer>
      <div class="w-100">
        <b-button
          variant="primary"
          class="float-right"
          @click="submit"
          :disabled="$v.form.$invalid"
        >
          Aceptar
        </b-button>
      </div>
    </template>
  </b-modal>
</template>

<script>
import moment from 'moment';
import { required, requiredIf, minLength, maxLength, numeric } from 'vuelidate/lib/validators';

export default {
    props: ['nroPoliza', 'tomador'],
    data() {
        return {
            visible: false,
            opcionesPago: [
                {
                    text: 'Opción 1: Débito en Tarjeta de Crédito',
                    value: 1
                },
                {
                    text: 'Opción 2: Débito Automático en Cuenta',
                    value: 2
                }
            ],
            opcionesAseg: [],
            form: {}
        }
    },
    validations: {
        form: {
            fecha: { required },            
            opcion: { required },
            tarjeta: {
                required: requiredIf(function() {
                    return this.form.opcion == 1
                }),
                marca: { required: requiredIf(function() { return this.form.opcion == 1 }) },
                numero: {
                    required: requiredIf(function() { return this.form.opcion == 1 }),
                    minLength: minLength(19),
                    maxLength: maxLength(19)
                },
                titular: { required: requiredIf(function() { return this.form.opcion == 1 }) },
                vencimiento: {
                    required: requiredIf(function() { return this.form.opcion == 1 })
                },
                banco: { required: requiredIf(function() { return this.form.opcion == 1 }) }
            },
            cuenta: {
                required: requiredIf(function() {
                    return this.form.opcion == 2
                }),
                tipo: {
                    required: requiredIf(function() {
                        return this.form.opcion == 2
                    }),
                },
                numero: {
                    required: requiredIf(function() {
                        return this.form.opcion == 2
                    }),
                },
                titular: {
                    required: requiredIf(function() {
                        return this.form.opcion == 2
                    }),
                },
                banco: {
                    required: requiredIf(function() {
                        return this.form.opcion == 2
                    }),
                },
                sucursal: {
                    required: requiredIf(function() {
                        return this.form.opcion == 2
                    }),
                    numeric
                },
                cbu: {
                    required: requiredIf(function() {
                        return this.form.opcion == 2
                    }),
                    minLength: minLength(22),
                    maxLength: maxLength(22),
                    numeric
                }
            }
        }
    },
    methods: {
        toggle() {
            this.visible = !this.visible
        },

        submit() {
            this.$v.form.$touch();

            if (this.$v.form.$invalid) {
                return null
            }

            this.toggle();

            const payload = {
                poliza: this.nroPoliza,
                fecha: this.form.fecha,
                pas: {
                    nombre: (this.$store.state.auth.nombre + ' ' + this.$store.state.auth.apellido).replace('null',''),
                    codigo: this.$store.state.auth.cod_agente,
                    pas_email: this.$store.state.auth.email
                }
            };

            payload.opcion = this.form.opcion;

            if (payload.opcion == 1) {
                payload.conducto = {
                    tarjeta: this.form.tarjeta,
                    opcion: 'Débito en Tarjeta de Crédito'
                };
            } else {
                payload.conducto = {
                    cuenta: this.form.cuenta,
                    opcion: 'Débito Automático en Cuenta'
                }
            }

            let load = this.$loading.show();
            return this.$api.post(`tomador/cambio-conducto-pago/${this.$route.params.cod_tomador}`, payload).then(() => {
                load.hide();
                this.$toast.success('Se he enviado solicitud de instrumento de pago del tomador.');
            }).catch((err) => {
                load.hide();
                this.$toast.error('Ocurrió un error al enviar la solicitud por de instrumento de pago');
                //console.log(err.response);
            });
        }
    },
    watch: {
        visible: async function (val) {
            if (val) {
                this.opcionesAseg = await this.$api(`polizas/asegurados/${this.nroPoliza}/0`)
                    .then(res => res.data.map(item => item.cod_aseg + ' - ' + item.nombre));

                this.form = {
                    fecha: moment().format('YYYY-MM-DD'),
                        asegurado: '',
                        opcion: null,
                        tarjeta: {
                        marca: '',
                            numero: ''
                    },
                    cuenta: {
                        tipo: '',
                            numero: '',
                            titular: '',
                            banco: '',
                            sucursal: '',
                            cbu: ''
                    }
                };

                this.$v.$reset();
            }
        }
    }
}
</script>
